// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trade-spinner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 5rem;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .trade-spiner:before,
  .trade-spinner:after {
    content: "";
    position: absolute;
    border-radius: 50%;
    animation: pulsOut 1.5s ease-in-out infinite;
    filter: drop-shadow(0 0 0.5rem rgba(255, 255, 255, 0.75));
  }
  .trade-spinner:before {
    width: 100%;
    padding-bottom: 100%;
    box-shadow: inset 0 0 0 0.5rem #fff;
    animation-name: pulsIn;
  }
  .trade-spinner:after {
    width: calc(100% - 1rem);
    padding-bottom: calc(100% - 1rem);
    box-shadow: 0 0 0 0 #fff;
  }

  @keyframes pulsIn {
    0% {
      box-shadow: inset 0 0 0 0.5rem #fff;
      opacity: 1;
    }
    50%, 100% {
      box-shadow: inset 0 0 0 0 #fff;
      opacity: 0;
    }
  }

  @keyframes pulsOut {
    0%, 50% {
      box-shadow: 0 0 0 0 #fff;
      opacity: 0;
    }
    100% {
      box-shadow: 0 0 0 0.5rem #fff;
      opacity: 1;
    }
  }
      
  /* 
    Trade URL Spinner below
  
  */

  .tradeUrl-spinner {
    width: 100%;
    height: 4.8px;
    display: inline-block;
    position: relative;
    overflow: hidden;
  }
  .tradeUrl-spinner::after {
    content: '';  
    width: 96px;
    height: 4.8px;
    background: #FFF;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    animation: hitZak 0.6s ease-in-out infinite alternate;
  }
  
  @keyframes hitZak {
    0% {
      left: 0;
      transform: translateX(-1%);
    }
    100% {
      left: 100%;
      transform: translateX(-99%);
    }
  }
      `, "",{"version":3,"sources":["webpack://./src/assets/styles/Spinner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,qBAAqB;EACvB;EACA;;IAEE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,yDAAyD;EAC3D;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,mCAAmC;IACnC,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,wBAAwB;EAC1B;;EAEA;IACE;MACE,mCAAmC;MACnC,UAAU;IACZ;IACA;MACE,8BAA8B;MAC9B,UAAU;IACZ;EACF;;EAEA;IACE;MACE,wBAAwB;MACxB,UAAU;IACZ;IACA;MACE,6BAA6B;MAC7B,UAAU;IACZ;EACF;;EAEA;;;GAGC;;EAED;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,sBAAsB;IACtB,qDAAqD;EACvD;;EAEA;IACE;MACE,OAAO;MACP,0BAA0B;IAC5B;IACA;MACE,UAAU;MACV,2BAA2B;IAC7B;EACF","sourcesContent":[".trade-spinner {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 5rem;\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n  .trade-spiner:before,\n  .trade-spinner:after {\n    content: \"\";\n    position: absolute;\n    border-radius: 50%;\n    animation: pulsOut 1.5s ease-in-out infinite;\n    filter: drop-shadow(0 0 0.5rem rgba(255, 255, 255, 0.75));\n  }\n  .trade-spinner:before {\n    width: 100%;\n    padding-bottom: 100%;\n    box-shadow: inset 0 0 0 0.5rem #fff;\n    animation-name: pulsIn;\n  }\n  .trade-spinner:after {\n    width: calc(100% - 1rem);\n    padding-bottom: calc(100% - 1rem);\n    box-shadow: 0 0 0 0 #fff;\n  }\n\n  @keyframes pulsIn {\n    0% {\n      box-shadow: inset 0 0 0 0.5rem #fff;\n      opacity: 1;\n    }\n    50%, 100% {\n      box-shadow: inset 0 0 0 0 #fff;\n      opacity: 0;\n    }\n  }\n\n  @keyframes pulsOut {\n    0%, 50% {\n      box-shadow: 0 0 0 0 #fff;\n      opacity: 0;\n    }\n    100% {\n      box-shadow: 0 0 0 0.5rem #fff;\n      opacity: 1;\n    }\n  }\n      \n  /* \n    Trade URL Spinner below\n  \n  */\n\n  .tradeUrl-spinner {\n    width: 100%;\n    height: 4.8px;\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n  }\n  .tradeUrl-spinner::after {\n    content: '';  \n    width: 96px;\n    height: 4.8px;\n    background: #FFF;\n    position: absolute;\n    top: 0;\n    left: 0;\n    box-sizing: border-box;\n    animation: hitZak 0.6s ease-in-out infinite alternate;\n  }\n  \n  @keyframes hitZak {\n    0% {\n      left: 0;\n      transform: translateX(-1%);\n    }\n    100% {\n      left: 100%;\n      transform: translateX(-99%);\n    }\n  }\n      "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
